import { Panel, VerticalContainer } from '@/components';
import { InfoIcon } from '@/components/Icons';

type WarningBannerProps = {
    title: string;
    description: string;
};

export const WarningBanner = ({ title, description }: WarningBannerProps) => {
    return (
        <Panel type="error">
            <VerticalContainer spacing="sm">
                <InfoIcon variant="error" />
                <h4 className="text-(--color-text-error)">{title}</h4>
                <p className="text-(--color-text-error)">{description}</p>
            </VerticalContainer>
        </Panel>
    );
};
